export const overridesCss = `
#productRoot [data-testid='fuse-modal__close-button']:not(#marketing-card-root [data-testid='fuse-modal__close-button']) {
  position: absolute;
}

#productRoot [data-testid='add_to_basket_button'],
#productRoot [data-testid='sticky_add_to_basket_button'],
#productRoot [data-testid='continue_with_purchase__button'],
#productRoot [data-testid='check-its-right-add-button'],
#productRoot [data-testid='continue-without-insurance-button'],
#productRoot [data-testid='close-dialog-button'] {
  width: 100%;
}
  
#productRoot .fuse-modal__close-button.fuse-modal__close-button {
  margin: 4px 0 0 8px;
}
  
#productRoot [data-testid='product-price__prev'] {
  margin-bottom: 0;
}
  
#productRoot [data-testid='fuse-alert__content'] p:last-child {
  margin-bottom: 0;
}

#productRoot [data-testid='insurance-radio-group'] .fuse-radio {
  align-items: flex-start;
}
  
#productRoot .fuse-alert {
  margin-bottom: 8px;
}

#productRoot .fuse-accordion-group__accordion:empty {
  display: none;
}

#productRoot [data-testid='fuse-tabs-tab-list-test-id'][data-testid='fuse-tabs-tab-list-test-id'] {
  margin-left: 0;
}

#esi-pdp-galleries {
  max-width: calc(100vw - 32px);
  width: 1280px;

  @media (min-width: 1024px) {
    max-width: calc(100vw - 48px);
  }
}
`.trim();
